module.exports = __webpack_public_path__ + "static/vue-core-d41342d83b31e960c37a8ae9be53c0a6.png";